module.exports = __webpack_public_path__ + "img/A9.cadb814e.png";